import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DismissIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.6423 19.1845C14.6423 19.6863 14.4637 20.1144 14.1065 20.4686C13.7493 20.8229 13.3279 21 12.8421 21C12.3563 21 11.9349 20.8229 11.5777 20.4686C11.2205 20.1144 11.0419 19.6863 11.0419 19.1845H14.6423ZM12.8421 3C13.2136 3 13.5315 3.13653 13.7958 3.40959C14.0601 3.68266 14.1922 4.01107 14.1922 4.39483V5.0369C15.0776 5.26556 15.8283 5.68451 16.4444 6.29374L18.5807 4.14462C18.9194 3.80396 19.4524 3.82122 19.7711 4.18317C20.0899 4.54513 20.0737 5.11472 19.735 5.45538L17.4815 7.72326C17.9604 8.64489 18.1998 9.69777 18.1998 10.8819V15.4649L20 17.3247V18.2325L7.03326 18.2316L5.41926 19.8554C5.08058 20.196 4.54764 20.1788 4.22889 19.8168C3.91014 19.4549 3.92629 18.8853 4.26496 18.5446L7.48379 15.3057L7.4844 10.8819C7.4844 9.43542 7.83443 8.1882 8.53451 7.14022C9.24888 6.06273 10.2418 5.36163 11.5134 5.0369V4.39483C11.5134 4.01107 11.642 3.68266 11.8991 3.40959C12.1563 3.13653 12.4706 3 12.8421 3ZM16.1047 9.10894L9.28421 15.9672L9.28459 16.417H16.3996V10.8819C16.3996 10.2452 16.3013 9.65423 16.1047 9.10894ZM12.8421 6.71956C12.1135 6.71956 11.4777 6.91144 10.9348 7.2952C10.4061 7.64945 9.99895 8.14391 9.71321 8.7786C9.42746 9.41329 9.28459 10.1144 9.28459 10.8819L9.28421 13.4949L15.1415 7.60396C15.0192 7.49133 14.8885 7.38841 14.7494 7.2952C14.2065 6.91144 13.5708 6.71956 12.8421 6.71956Z'
                fill='currentColor'
            />
        </>
    ),
})

DismissIcon.displayName = 'DismissIcon'
